import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChartCompare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChartCompare"><Path d="M4.5 19.5H21V21H3V3H4.5V19.5Z" fill="currentColor"/><Path d="M8.5 18.25H7V11H8.5V18.25Z" fill="currentColor"/><Path d="M11.5 18.25H10V7H11.5V18.25Z" fill="currentColor"/><Path d="M16.5 18.25H15V9H16.5V18.25Z" fill="currentColor"/><Path d="M19.5 18.25H18V5H19.5V18.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChartCompare;
